<!--
 * @Author: your name
 * @Date: 2022-01-07 15:30:27
 * @LastEditTime: 2022-02-21 13:22:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \nqc-pc-ui\src\frameworks\layouts\components\Sidebar\Item.vue
-->
<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon} />)
    }

    if (title) {
      vnodes.push(
        <span slot="title" class="show-ellipsis">
          {title}
        </span>
      )
    }
    return vnodes
  }
}
</script>
